import { useEffect } from 'react';
import { parseQueryParams, scrollToBlock } from '@fttb/common/utils';
import { FttbBlocks } from "../../constants";
import { isValidAddress } from "./utils";

/** хук проверяет наличие адреса в url-строке после редиректа на регион */
export var useInitAddressAndScrollTo = function useInitAddressAndScrollTo(onMount) {
  useEffect(function () {
    var search = window.location.search;
    var initAddress = Object.fromEntries(parseQueryParams(search));
    if (isValidAddress(initAddress)) {
      onMount === null || onMount === void 0 || onMount(initAddress);
      var newUrl = window.location.href.replace(search, '');
      window.history.replaceState({}, '', newUrl);
      setTimeout(function () {
        scrollToBlock(FttbBlocks.CHECK_ADDRESS);
      }, 1000);
    }
  }, []);
};